import React from 'react';
import CartIcon from './CartIcon';
import { useGetAllOrdersQuery } from '../../services/endpoints/orders/orders';
import { useCartContext } from '../../context/CartContext';
import { getCurrentUser } from '../../services/helper';

/**
 * Cart badge that prefers the server's view of incomplete orders for the
 * logged-in user. Falls back to localStorage course_ids when the user is
 * anonymous so anonymous users still see something they added before signing in.
 */
const CartIconWithCount: React.FC = () => {
  const cartContext = useCartContext();
  const currentUser = getCurrentUser();

  const { data } = useGetAllOrdersQuery(
    {
      data: {
        page: 1,
        entries: 100,
        filterBy: currentUser?.id
          ? [{ field: 'parent_id', operator: 'equals', value: currentUser.id }]
          : []
      },
      scope: 'incomplete'
    },
    { skip: !currentUser?.id, refetchOnMountOrArgChange: true }
  );

  const serverCount = data?.results?.length ?? 0;
  const localCount = cartContext.courseIds.length;
  const itemCount = currentUser?.id ? serverCount : localCount;

  return <CartIcon itemCount={itemCount} />;
};

export default CartIconWithCount;
